function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* script */
//
//
//
//
//
//
import { HTMLElementType } from '@cloud-sn/v-utils';
import { offset, isTransform3dSupported } from './utils';
var __vue_script__ = {
  name: 'InkTabBar',
  props: {
    prefixCls: String,
    inkBarAnimated: {
      type: Boolean,
      default: true
    },
    wrapNode: HTMLElementType(),
    activeTab: HTMLElementType(),
    tabBarPosition: String,
    size: String
  },
  data: function data() {
    return {
      isSupportedTransform3d: isTransform3dSupported()
    };
  },
  computed: {
    classes: function classes() {
      var _ref;

      var rootPrefixCls = this.prefixCls,
          inkBarAnimated = this.inkBarAnimated;
      var prefixCls = "".concat(rootPrefixCls, "-ink-bar");
      return _ref = {}, _defineProperty(_ref, prefixCls, true), _defineProperty(_ref, "".concat(prefixCls, "-animated"), inkBarAnimated), _defineProperty(_ref, "".concat(prefixCls, "-no-animated"), !inkBarAnimated), _ref;
    },
    inkBarStyle: function inkBarStyle() {
      var activeTab = this.activeTab,
          wrapNode = this.wrapNode,
          tabBarPosition = this.tabBarPosition,
          isSupportedTransform3d = this.isSupportedTransform3d,
          size = this.size;
      var style = {};

      if (!wrapNode || !size) {
        return style;
      }

      var activeNode = activeTab;

      if (activeNode) {
        var wrapOffset = offset(wrapNode);
        var activeOffset = offset(activeNode);

        if (tabBarPosition === 'top' || tabBarPosition === 'bottom') {
          var left = activeOffset.left - wrapOffset.left;
          var width = activeNode.offsetWidth;

          if (isSupportedTransform3d) {
            style = {
              width: "".concat(width, "px"),
              transform: "translate3d(".concat(left, "px, 0 ,0)")
            };
          } else {
            style = {
              left: "".concat(left, "px"),
              width: "".concat(width, "px")
            };
          }
        } else {
          var top = activeOffset.top - wrapOffset.top;
          var height = activeNode.offsetHeight;

          if (isSupportedTransform3d) {
            style = {
              height: "".concat(height, "px"),
              transform: "translate3d(0, ".concat(top, "px, 0)")
            };
          } else {
            style = {
              height: "".concat(height, "px"),
              top: "".concat(top, "px")
            };
          }
        }

        style.display = 'block';
      } else {
        style.display = 'none';
      }

      return style;
    }
  }
};
/* template */

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: _vm.classes,
    style: _vm.inkBarStyle,
    attrs: {
      "role": "inkBar"
    }
  });
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* component normalizer */

function __vue_normalize__(template, style, script, scope, functional) {
  var component = (typeof script === 'function' ? script.options : script) || {}; // For security concerns, we use only base name in production mode.

  component.__file = "inkTabBar.js";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;
  return component;
}
/* style inject */

/* style inject SSR */


export default __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, undefined, undefined);